import { ProductDesign, ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';

const openFramesProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  infoButtonAriaLabel: 'storageone.openFramesMenuTitle',
  mobileCardText: 'communicatedSizeText',
  productFilters: [],
  cluster: [],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  sortOrder: [],
  categories: [
    {
      id: 'open-frames-white',
      products: [
        { path: 'type', value: ProductType.ENHET_WALL_FRAME },
        { path: 'design', value: ProductDesign.WHITE }
      ]
    },
    {
      id: 'open-frames-anthracite',
      products: [
        { path: 'type', value: ProductType.ENHET_WALL_FRAME },
        { path: 'design', value: ProductDesign.ANTHRACITE }
      ]
    }
  ]
};

export default openFramesProductListConfig;
